$(document).ready(function() {
  $.fn.select2.defaults.set( "theme", "bootstrap4" );
});
